require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-10-questions-with-paula-hayes.json") })
        }
      }, "path---news-10-questions-with-paula-hayes");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-10-questions-with-paula-hayes!./.cache/json/news-10-questions-with-paula-hayes.json
// module id = 1414
// module chunks = 231608221292675